var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("HubBoxSimple", {
    attrs: { icon: "", title: "", fillHeight: "" },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              [
                _c("IconNumberTeaser", {
                  attrs: {
                    title: _vm.positive
                      ? _vm.$t("stats.feedbackPositive")
                      : _vm.$t("stats.feedbackNegative"),
                    icon: _vm.positive ? "thumb_up" : "thumb_down",
                    oldValue: _vm.sumOld,
                    newValue: _vm.sumNew,
                    loading: _vm.isLoading,
                    compareDisabled: !_vm.dateRangeCompare
                      ? _vm.$t("dateRange.selectComparePeriod")
                      : "",
                    titleHeading: "",
                    lessIsBetter: !_vm.positive,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "relative my-4 mx-n4" },
              [
                _c("v-divider"),
                _vm.isLoading
                  ? _c("v-progress-linear", {
                      staticStyle: {
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                      },
                      attrs: { indeterminate: "", color: "secondary darken-2" },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("StatsChart", {
              attrs: {
                isLoading: _vm.isLoading,
                seriesData: _vm.seriesData,
                seriesDataCompare: _vm.seriesDataCompare,
                colorSchema: _vm.chartColorSchema,
                dateRange: _vm.dateRange,
                dateRangeCompare: _vm.dateRangeCompare,
                max: _vm.max,
                timeFormat: _vm.timeFormat,
                type: "bar",
                fixedNumbers: "",
                opposite: "",
                height: _vm.height,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }